// ⚠️ THIS FILE IS AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated by: scripts/generate-point-path.ts
// Source: src/types/path/fieldDefinitions.ts
// To modify: Update fieldDefinitions.ts and run: npm run generate:point

/**
 * Enum defining the index of each field in the chunked array storage.
 * Based on PropertyKeys.java from gpx2web project.
 * Each point has exactly 36 numeric values stored contiguously.
 */
export enum PointField {
    // Coordinates (4 properties)
    LATITUDE = 0, // Latitude (radians)
    LONGITUDE = 1, // Longitude (radians)
    DISTANCE = 2, // Distance (meters)
    DX = 3, // dx (meters)

    // Temporal (3 properties)
    TIME = 4, // Timestamp (ms since epoch)
    ELAPSED = 5, // Elapsed duration (ms)
    DT = 6, // dt (ms)

    // Angles (1 properties)
    BEARING = 7, // Direction bearing (radians)

    // 🏔️ Elevation (1 properties)
    ELEVATION = 8, // Elevation (meters)

    // 📐 Grade (1 properties)
    GRADE = 9, // Road grade/slope (%)

    // Radius (1 properties)
    RADIUS = 10, // Turn radius (meters)

    // Aero coef (1 properties)
    AERO_COEF = 11, // Aerodynamic coefficient

    // Cyclist wind (2 properties)
    WIND_BEARING = 12, // Wind bearing (radians)
    WIND_ALPHA = 13, // Wind angle (radians)

    // ⚡ Power Physics (4 properties)
    P_AERO = 14, // Aerodynamic power
    P_GRAVITY = 15, // Gravitational power
    P_ROLLING_RESISTANCE = 16, // Rolling resistance power
    P_WHEEL_BEARINGS = 17, // Wheel bearings power

    // ⚡ Power Cyclist (6 properties)
    P_INPUT_POWER = 18, // GPX input power
    P_CYCLIST_PROVIDED_OPTIMAL_POWER = 19, // Optimal power
    P_CYCLIST_PROVIDED_OPTIMAL_POWER_HARMONICS = 20, // Optimal power with harmonics
    P_CYCLIST_PROVIDED_POWER_NEEDED = 21, // Power needed
    P_CYCLIST_PROVIDED_MUSCULAR = 22, // Raw cyclist power
    P_CYCLIST_PROVIDED_WHEEL = 23, // Cyclist power transmitted to ground

    // ⚡ Power Post processed (3 properties)
    P_COMPUTED_TOTAL_POWER = 24, // Power from kinetic energy change
    P_COMPUTED_WHEEL_POWER = 25, // Wheel power from kinetic energy change
    POWER = 26, // Total power (watts)

    // Speed & Motion (4 properties)
    SPEED = 27, // Current speed (m/s)
    SPEED_MAX = 28, // Maximum speed (m/s)
    SPEED_MAX_INCLINE = 29, // Max speed on incline (m/s)
    VIRT_SPEED_CURRENT = 30, // Virtual current speed (m/s)

    // Environmental (3 properties)
    TEMPERATURE = 31, // Temperature (celsius)
    WIND_SPEED = 32, // Wind speed (m/s)
    WIND_DIRECTION = 33, // Wind direction (radians)

    // Physiological (2 properties)
    HEART_RATE = 34, // Heart rate (bpm)
    CADENCE = 35, // Pedaling cadence (rpm)
}

export const POINT_FIELDS: PointField[] = [
    // Coordinates (4 properties)
    PointField.LATITUDE, // Latitude (radians)
    PointField.LONGITUDE, // Longitude (radians)
    PointField.DISTANCE, // Distance (meters)
    PointField.DX, // dx (meters)

    // Temporal (3 properties)
    PointField.TIME, // Timestamp (ms since epoch)
    PointField.ELAPSED, // Elapsed duration (ms)
    PointField.DT, // dt (ms)

    // Angles (1 properties)
    PointField.BEARING, // Direction bearing (radians)

    // 🏔️ Elevation (1 properties)
    PointField.ELEVATION, // Elevation (meters)

    // 📐 Grade (1 properties)
    PointField.GRADE, // Road grade/slope (%)

    // Radius (1 properties)
    PointField.RADIUS, // Turn radius (meters)

    // Aero coef (1 properties)
    PointField.AERO_COEF, // Aerodynamic coefficient

    // Cyclist wind (2 properties)
    PointField.WIND_BEARING, // Wind bearing (radians)
    PointField.WIND_ALPHA, // Wind angle (radians)

    // ⚡ Power Physics (4 properties)
    PointField.P_AERO, // Aerodynamic power
    PointField.P_GRAVITY, // Gravitational power
    PointField.P_ROLLING_RESISTANCE, // Rolling resistance power
    PointField.P_WHEEL_BEARINGS, // Wheel bearings power

    // ⚡ Power Cyclist (6 properties)
    PointField.P_INPUT_POWER, // GPX input power
    PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER, // Optimal power
    PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER_HARMONICS, // Optimal power with harmonics
    PointField.P_CYCLIST_PROVIDED_POWER_NEEDED, // Power needed
    PointField.P_CYCLIST_PROVIDED_MUSCULAR, // Raw cyclist power
    PointField.P_CYCLIST_PROVIDED_WHEEL, // Cyclist power transmitted to ground

    // ⚡ Power Post processed (3 properties)
    PointField.P_COMPUTED_TOTAL_POWER, // Power from kinetic energy change
    PointField.P_COMPUTED_WHEEL_POWER, // Wheel power from kinetic energy change
    PointField.POWER, // Total power (watts)

    // Speed & Motion (4 properties)
    PointField.SPEED, // Current speed (m/s)
    PointField.SPEED_MAX, // Maximum speed (m/s)
    PointField.SPEED_MAX_INCLINE, // Max speed on incline (m/s)
    PointField.VIRT_SPEED_CURRENT, // Virtual current speed (m/s)

    // Environmental (3 properties)
    PointField.TEMPERATURE, // Temperature (celsius)
    PointField.WIND_SPEED, // Wind speed (m/s)
    PointField.WIND_DIRECTION, // Wind direction (radians)

    // Physiological (2 properties)
    PointField.HEART_RATE, // Heart rate (bpm)
    PointField.CADENCE, // Pedaling cadence (rpm)
];

export const fieldToPointField: Record<string, PointField> = {
    // Coordinates (4 properties)
    latitude: PointField.LATITUDE, // Latitude (radians)
    longitude: PointField.LONGITUDE, // Longitude (radians)
    distance: PointField.DISTANCE, // Distance (meters)
    dx: PointField.DX, // dx (meters)

    // Temporal (3 properties)
    time: PointField.TIME, // Timestamp (ms since epoch)
    elapsed: PointField.ELAPSED, // Elapsed duration (ms)
    dt: PointField.DT, // dt (ms)

    // Angles (1 properties)
    bearing: PointField.BEARING, // Direction bearing (radians)

    // 🏔️ Elevation (1 properties)
    elevation: PointField.ELEVATION, // Elevation (meters)

    // 📐 Grade (1 properties)
    grade: PointField.GRADE, // Road grade/slope (%)

    // Radius (1 properties)
    radius: PointField.RADIUS, // Turn radius (meters)

    // Aero coef (1 properties)
    aeroCoef: PointField.AERO_COEF, // Aerodynamic coefficient

    // Cyclist wind (2 properties)
    windBearing: PointField.WIND_BEARING, // Wind bearing (radians)
    windAlpha: PointField.WIND_ALPHA, // Wind angle (radians)

    // ⚡ Power Physics (4 properties)
    pAero: PointField.P_AERO, // Aerodynamic power
    pGravity: PointField.P_GRAVITY, // Gravitational power
    pRollingResistance: PointField.P_ROLLING_RESISTANCE, // Rolling resistance power
    pWheelBearings: PointField.P_WHEEL_BEARINGS, // Wheel bearings power

    // ⚡ Power Cyclist (6 properties)
    pInputPower: PointField.P_INPUT_POWER, // GPX input power
    pCyclistProvidedOptimalPower: PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER, // Optimal power
    pCyclistProvidedOptimalPowerWithHarmonics:
        PointField.P_CYCLIST_PROVIDED_OPTIMAL_POWER_HARMONICS, // Optimal power with harmonics
    pCyclistPowerNeeded: PointField.P_CYCLIST_PROVIDED_POWER_NEEDED, // Power needed
    pCyclistProvidedMuscular: PointField.P_CYCLIST_PROVIDED_MUSCULAR, // Raw cyclist power
    PCyclistProvidedWheel: PointField.P_CYCLIST_PROVIDED_WHEEL, // Cyclist power transmitted to ground

    // ⚡ Power Post processed (3 properties)
    pComputedTotalPower: PointField.P_COMPUTED_TOTAL_POWER, // Power from kinetic energy change
    pComputedWheelPower: PointField.P_COMPUTED_WHEEL_POWER, // Wheel power from kinetic energy change
    pComputedPower: PointField.POWER, // Total power (watts)

    // Speed & Motion (4 properties)
    speed: PointField.SPEED, // Current speed (m/s)
    speedMax: PointField.SPEED_MAX, // Maximum speed (m/s)
    speedMaxIncline: PointField.SPEED_MAX_INCLINE, // Max speed on incline (m/s)
    virtSpeedCurrent: PointField.VIRT_SPEED_CURRENT, // Virtual current speed (m/s)

    // Environmental (3 properties)
    temperature: PointField.TEMPERATURE, // Temperature (celsius)
    windSpeed: PointField.WIND_SPEED, // Wind speed (m/s)
    windDirection: PointField.WIND_DIRECTION, // Wind direction (radians)

    // Physiological (2 properties)
    heartRate: PointField.HEART_RATE, // Heart rate (bpm)
    cadence: PointField.CADENCE, // Pedaling cadence (rpm)
};

/**
 * Total number of fields per point in the chunked storage.
 */
export const FIELDS_PER_POINT = 36;

/**
 * Interface representing a complete point with all 36 properties.
 * All values are stored as numbers with appropriate unit conversions.
 *
 * Note: Angles are stored in RADIANS for efficient physics calculations.
 */
export interface Point {
    // Coordinates
    readonly latitude: number; // Latitude (radians)
    readonly longitude: number; // Longitude (radians)
    readonly distance: number; // Distance (meters)
    readonly dx: number; // dx (meters)

    // Temporal
    readonly time: number; // Timestamp (ms since epoch)
    readonly elapsed: number; // Elapsed duration (ms)
    readonly dt: number; // dt (ms)

    // Angles
    readonly bearing: number; // Direction bearing (radians)

    // 🏔️ Elevation
    readonly elevation: number; // Elevation (meters)

    // 📐 Grade
    readonly grade: number; // Road grade/slope (%)

    // Radius
    readonly radius: number; // Turn radius (meters)

    // Aero coef
    readonly aeroCoef: number; // Aerodynamic coefficient

    // Cyclist wind
    readonly windBearing: number; // Wind bearing (radians)
    readonly windAlpha: number; // Wind angle (radians)

    // ⚡ Power Physics
    readonly pAero: number; // Aerodynamic power
    readonly pGravity: number; // Gravitational power
    readonly pRollingResistance: number; // Rolling resistance power
    readonly pWheelBearings: number; // Wheel bearings power

    // ⚡ Power Cyclist
    readonly pInputPower: number; // GPX input power
    readonly pCyclistProvidedOptimalPower: number; // Optimal power
    readonly pCyclistProvidedOptimalPowerWithHarmonics: number; // Optimal power with harmonics
    readonly pCyclistPowerNeeded: number; // Power needed
    readonly pCyclistProvidedMuscular: number; // Raw cyclist power
    readonly PCyclistProvidedWheel: number; // Cyclist power transmitted to ground

    // ⚡ Power Post processed
    readonly pComputedTotalPower: number; // Power from kinetic energy change
    readonly pComputedWheelPower: number; // Wheel power from kinetic energy change
    readonly pComputedPower: number; // Total power (watts)

    // Speed & Motion
    readonly speed: number; // Current speed (m/s)
    readonly speedMax: number; // Maximum speed (m/s)
    readonly speedMaxIncline: number; // Max speed on incline (m/s)
    readonly virtSpeedCurrent: number; // Virtual current speed (m/s)

    // Environmental
    readonly temperature: number; // Temperature (celsius)
    readonly windSpeed: number; // Wind speed (m/s)
    readonly windDirection: number; // Wind direction (radians)

    // Physiological
    readonly heartRate: number; // Heart rate (bpm)
    readonly cadence: number; // Pedaling cadence (rpm)
}

type Writable<T> = {
    -readonly [K in keyof T]: T[K];
};

export type PointWritable = Writable<Point>;

export const EMPTY_POINT: Point = {
    // Coordinates
    latitude: NaN,
    longitude: NaN,
    distance: NaN,
    dx: NaN,
    // Temporal
    time: NaN,
    elapsed: NaN,
    dt: NaN,
    // Angles
    bearing: NaN,
    // 🏔️ Elevation
    elevation: NaN,
    // 📐 Grade
    grade: NaN,
    // Radius
    radius: NaN,
    // Aero coef
    aeroCoef: NaN,
    // Cyclist wind
    windBearing: NaN,
    windAlpha: NaN,
    // ⚡ Power Physics
    pAero: NaN,
    pGravity: NaN,
    pRollingResistance: NaN,
    pWheelBearings: NaN,
    // ⚡ Power Cyclist
    pInputPower: NaN,
    pCyclistProvidedOptimalPower: NaN,
    pCyclistProvidedOptimalPowerWithHarmonics: NaN,
    pCyclistPowerNeeded: NaN,
    pCyclistProvidedMuscular: NaN,
    PCyclistProvidedWheel: NaN,
    // ⚡ Power Post processed
    pComputedTotalPower: NaN,
    pComputedWheelPower: NaN,
    pComputedPower: NaN,
    // Speed & Motion
    speed: NaN,
    speedMax: NaN,
    speedMaxIncline: NaN,
    virtSpeedCurrent: NaN,
    // Environmental
    temperature: NaN,
    windSpeed: NaN,
    windDirection: NaN,
    // Physiological
    heartRate: NaN,
    cadence: NaN,
};
